import { createFileRoute } from '@tanstack/react-router'
import { encountersQueryOptions } from '~/features/dashboard/pages/encounters/api/queries';
import { PaymentsPage } from '~/features/dashboard/pages/payments/pages';

export const Route = createFileRoute('/(dashboard)/dashboard/$program/payments/$tab')({
  beforeLoad: async ({ params }) => {
    const type = params.tab;
    if (type !== "consultation" && type !== "appointment" && type !== "refill") {
      return "all";
    }
  },
  loader: ({ context, params }) => {
    context.queryClient.ensureQueryData(encountersQueryOptions({ limit: 10, skip: 0, type: params.tab === "all" ? undefined : params.tab as "consultation" | "appointment" | "refill", date_filter: "all", type_sort_order: params.tab === "all" ? undefined : params.tab as "consultation" | "appointment" | "refill" }))
  },
  component: () => (
    <PaymentsPage />
  ),
})
